export const AIS3_COMMENTS_REQUEST_API_PREFIX = 'ais3.comments.request.result';
